var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{attrs:{"bg":"","fill-height":"","grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',[_c('LayoutMain',[_vm._t("default")],2)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }